import * as React from "react";
import { forwardRef } from "react";
const SvgDottedCircle = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="none" fillRule="evenodd" stroke="currentColor" strokeDasharray="1.5 3.8" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 15c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z" /></svg>;
const ForwardRef = forwardRef(SvgDottedCircle);
export { ForwardRef as ReactComponent };